import axios from "axios";

import { getAppEnv } from "env/env";

const getAccessToken = () => sessionStorage.getItem("accessToken");

export const axiosGetInstance = async () => {
  const accessToken = await getAccessToken();
  const instance = axios.create({
    headers: {
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
    },
    withCredentials: false,
  });

  return instance;
};

export const axiosPostCIAMInstance =  () => {
  //const accessToken = await getAccessToken();
  const instance = axios.create({
    withCredentials: true,
  });

  return instance;
};

export const axiosPostInstance = () => {
  const accessToken = getAccessToken();
  const instance = axios.create({
    headers: {
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
      "Content-Type": "application/json",
      Accept: "application/json",
      "Client-Id": getAppEnv().IBM_CLIENT_ID,
    },
    withCredentials: false,
  });

  return instance;
};

export const axiosPostInstanceUW = () => {
  const accessToken = getAccessToken();
  const instance = axios.create({
    headers: {
      Authorization: accessToken ? `Bearer ${accessToken}` : "",
      "Content-Type": "application/json",
      Accept: "application/json, text/html",
      "Client-Id": getAppEnv().IBM_CLIENT_ID,
    },
    withCredentials: false,
  });

  return instance;
};

export const axiosPCPostInstance = () => {
  const instance = axios.create({
    headers: {
      "Content-Type": "application/soap+xml, application/json,application/text, application/xml",
      Accept: "application/soap+xml, application/json, application/text, application/xml",
    },
    withCredentials: false,
  });
 
  return instance;
};